import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { MAP_STYLES } from "@/constants/map";
import { useMap } from "@/hooks/map/core/useMapContext";
import { RootState } from "@/store";
import { setMapStyle } from "@/store/slice/mapSlice";
import { transformStyle } from "@/utils/map";

import MapMenuItemControl from "../menuItemControl";

export default function BaseMapMenu() {
  const dispatch = useDispatch();
  const { baseMapRef, map } = useMap();
  const { baseMap } = useSelector((state: RootState) => state.map);
  const [isShowMenu, setIsShowMenu] = useState(false);

  const handleClickBaseMap = (key: keyof typeof MAP_STYLES) => {
    dispatch(setMapStyle(key));
    setIsShowMenu(false);

    const nextStyle = MAP_STYLES[key];

    if (nextStyle == null) return;
    if (JSON.stringify(baseMapRef.current) === JSON.stringify(nextStyle))
      return;

    map?.setStyle(nextStyle.value, {
      diff: true,
      transformStyle
    });

    baseMapRef.current = nextStyle.value;
  };

  return (
    <>
      <MapMenuItemControl
        aria-label={baseMap.title}
        tooltipContent={
          <div>
            <p className="font-semibold text-xs mb-1">Basemap Selection</p>
            <p>Choose a style to adjust the map display</p>{" "}
          </div>
        }
        onClick={() => setIsShowMenu(true)}
        className="relative w-16 h-16 mt-3 rounded-xl border border-neutral-200 shadow-[inset_0_4px_8px_rgba(0,0,0,0.2)] overflow-hidden hover:border-teal-500 cursor-pointer focus:outline-none"
      >
        <img
          src={`/intelligence/${baseMap.thumbnail}`}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent" />
        <p className="absolute bottom-1 left-0 right-0 text-center text-white text-[10px]">
          {baseMap.title}
        </p>
      </MapMenuItemControl>

      {isShowMenu && (
        <div className="flex flex-row items-center absolute gap-4 p-2 rounded-xl bottom-0 -left-2 -translate-x-full bg-white">
          {Object.entries(MAP_STYLES)
            .filter(([_key, value]) => value.value !== baseMap.value)
            .map(([key, value]) => {
              return (
                <MapMenuItemControl
                  aria-label={value.title}
                  key={key}
                  tooltipContent={
                    <div>
                      <p className="font-semibold text-xs mb-1">
                        {value.title}
                      </p>
                      <p>{value.description}</p>{" "}
                    </div>
                  }
                  onClick={() => {
                    handleClickBaseMap(key as keyof typeof MAP_STYLES);
                  }}
                  tooltipPosition="top-center"
                  className="w-12 h-12 rounded-xl border border-neutral-200 bg-[linear-gradient(180deg,_rgba(0,0,0,0)_-48.39%,_rgba(0,0,0,0.2)_62.19%),_var(--background-bg-inversed,_#FFF)] overflow-hidden hover:border-teal-500 cursor-pointer"
                >
                  <img
                    src={`/intelligence/${value.thumbnail}`}
                    alt=""
                    className="w-full h-full object-contain"
                  />
                </MapMenuItemControl>
              );
            })}
        </div>
      )}
    </>
  );
}
